import React from 'react';
import PropTypes from 'prop-types';
import { StyledWrapper, StyledH4, StyledP, StyledFormSwitcher } from './AccountFormStyles';

var _ref2 = React.createElement(
  StyledH4,
  null,
  'See Something',
  React.createElement('br', null),
  ' You Love?'
);

var _ref3 = React.createElement(
  StyledP,
  null,
  'Sign Up or Log In to save your faves!'
);

var _ref4 = React.createElement('br', null);

var WishlistForm = function WishlistForm(_ref) {
  var toggleAccountForm = _ref.toggleAccountForm,
      isModal = _ref.isModal;
  return React.createElement(
    StyledWrapper,
    { isModal: isModal },
    _ref2,
    _ref3,
    _ref4,
    React.createElement(
      'button',
      {
        className: 'btn btn--full gradient-shimmer',
        onClick: function onClick() {
          return toggleAccountForm({ formType: 'LOGIN' });
        }
      },
      'Log In'
    ),
    React.createElement(
      StyledFormSwitcher,
      {
        onClick: function onClick() {
          return toggleAccountForm({ formType: 'REGISTER' });
        }
      },
      'Create Account'
    )
  );
};

WishlistForm.propTypes = {
  toggleAccountForm: PropTypes.func.isRequired,
  isModal: PropTypes.bool
};

export default WishlistForm;